// extracted by mini-css-extract-plugin
export var article = "ProductAndArticle-module--article--2b5jo";
export var articleImage = "ProductAndArticle-module--articleImage--dp0BP";
export var articleLabel = "ProductAndArticle-module--articleLabel--EyWOa";
export var wrapper = "ProductAndArticle-module--wrapper--O4t99";